import { render, staticRenderFns } from "./MostrarDetalleLicenciaDialogComponent.vue?vue&type=template&id=57aae172"
import script from "./MostrarDetalleLicenciaDialogComponent.vue?vue&type=script&lang=js"
export * from "./MostrarDetalleLicenciaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports